<section id="tips" class="section tips">
    <div class="container is-fullhd">
        <div class="columns">
            <div class="tips__top">
                <ng-container  *ngTemplateOutlet="images"></ng-container>
            </div>
            <div class="column tips__list">
                <ul>
                    <li *ngFor="let item of tipsText">
                        <p>
                            <span class="tips__list-text">{{item.label}}</span>
                        </p>
                    </li>
                </ul>
            </div>
            <div class="tips__bottom">
                <ng-container  *ngTemplateOutlet="images"></ng-container>
            </div>

        </div>
    </div>
</section>

<ng-template #images>
    <div class="column tips__images">
        <div class="columns">
            <div class="column tips__images tips__images-first">
                <div class="tips__images-item tips__images-item__principal">
                    <div class="overlay-img"></div>
                </div>
            </div>
            <div class="column tips__images-last">
                <div class="columns">
                    <div class="column">
                        <div class="tips__images-item tips__images-item__secondary">
                            <div class="overlay-img"></div>
                        </div>
                        <div class="tips__images-item tips__images-item__tertiary">
                            <div class="overlay-img"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-template>
